window.env = window.env || {};
window.env.adminApp = true;

export default window.env;
